import { Navigate, createFileRoute } from '@tanstack/react-router';

import { Route as InvitesRoute } from '@/app/routes/_authenticated/invites';
import { Route as OnboardRoute } from '@/app/routes/_authenticated/onboard';
import { organizationsApi } from '@/features/organisations/api/organisation-api';
import { useUserOrganisations } from '@/features/organisations/api/organisation-queries';
import { teamApi } from '@/features/team/api/team-api';
import { useUserInvites } from '@/features/team/api/team-queries';
import { ensureQueryData } from '@/utils/ensure-query-data';

export const Route = createFileRoute('/_authenticated/')({
  loader: async ({ context: { queryClient, auth } }) => {
    const ensurePromises = [
      ensureQueryData(
        queryClient,
        organizationsApi.getUserOrganizations(auth.user.id),
      ),
      ensureQueryData(queryClient, teamApi.getUserInvites(auth.user.email)),
    ];

    return Promise.all(ensurePromises);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { auth } = Route.useRouteContext();

  const { data: organisations } = useUserOrganisations(auth.user.id);
  const { data: invites } = useUserInvites(auth.user.email);

  if (organisations.length > 0) {
    return <Navigate from={Route.fullPath} to={`/${organisations[0].id}`} />;
  }

  if (invites.length > 0) {
    return <Navigate from={Route.fullPath} to={InvitesRoute.to} />;
  }

  return <Navigate from={Route.fullPath} to={OnboardRoute.to} />;
}
